// extracted by mini-css-extract-plugin
export default {"copyButton":"TeamMember_copyButton__tJGs7"};